import { VALID_CC } from 'common/regex';
const CLEAN_CC_NUMBER = /[\s-]/g;

/*
 Luhn Validation Algorithm
 */
export function isValidCreditCardNumber(number) {
  let cleanNum = number;
  if (number) {
    cleanNum = number.replace(CLEAN_CC_NUMBER, '');
  }
  const luhnCheck = (function (arr) {
    return function (ccNum) {
      let bit = 1,
        len = ccNum.length,
        sum = 0,
        val;

      while (len) {
        val = parseInt(ccNum.charAt(--len), 10);
        sum += ((bit ^= 1)) ? arr[val] : val;
      }
      return sum && sum % 10 === 0;
    };
  }([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

  return VALID_CC.test(cleanNum) && luhnCheck(cleanNum);
}
